import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import ChatRoundedIcon from "@mui/icons-material/ChatRounded";
import HowToRegRoundedIcon from "@mui/icons-material/HowToRegRounded";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import DriveFolderUploadRoundedIcon from "@mui/icons-material/DriveFolderUploadRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { Badge, IconButton, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import CoreChip from "../../../app/core/components/CoreChip/CoreChip";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import CoreModal from "../../../app/core/components/CoreModal/CoreModal";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import CoreTable from "../../../app/core/components/CoreTable/CoreTable";
import UserFilter from "../../../app/core/components/UserFilter/UserFilter";
import { ROLE, SUB_ROLE } from "../../../utils/constants/profiles";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import { useGetStudiosQuery } from "../../api/admin/gestisciStudioApi";
import {
  useAssociateUserMutation,
  useGetUsersQuery,
  useGetUsersQuery as useGetUsersQueryForSelect,
} from "../../api/admin/gestisciUtentiApi";
import SchedaUtente from "../../common/SchedaUtente/SchedaUtente";
import GestioneUtentiFilter from "./GestioneUtentiFilter";
import { doReportUtente } from "./gestisciUtentiSlice";
import { labelForFilterGestioneUser } from "../../../utils/functions/filters";
import { useGetCompaniesQuery } from "../../api/admin/adminCompany";
import { useGetCommercialistaQuery } from "../../api/admin/gestisciCommercialistiApi";
import { useGetPracticesServicesQuery } from "../../api/admin/gestisciPraticheApi";
import { useGetProfileCategoryQuery } from "../../api/admin/gestioneNewsApi";
import { useTranslation } from "react-i18next";
import { formatItalianDate } from "../../../utils/functions/date-utils";
import i18n from "../../../../public/i18n";

const GestisciUtentiPage = () => {
  const { t } = useTranslation();
  const appConfig = useSelector((state) => state.app.appConfig);
  const role = useSelector((state) => state.app.role);
  const subrole = useSelector((state) => state.app.subRole);
  const columns = [
    { id: "lastDocUploadedAt", label: i18n.t("LastSubmission") },
    { id: "name", label: i18n.t("Name") },
    { id: "cf", label: i18n.t("CF") + "/" + t("VAT") },
    { id: "email", label: "Email" },
    ...(appConfig?.modules?.company?.general
      ? [{ id: "company", label: i18n.t("Company") }]
      : []),
    ...(ROLE.ADMIN === role ? [{ id: "studio", label: i18n.t("Studio") }] : []),
    { id: "type", label: i18n.t("Type") },
    { id: "actions", label: i18n.t("Actions") },
  ];

  const withDocumentsStatus = [
    { name: t("Sended"), value: true },
    { name: t("Unsended"), value: false },
  ];

  const sortIds = columns
    .map((el) => el.id)
    .filter(
      (id) =>
        !["lastDocUploadedAt", "name", "surname", "company", "studio"].includes(
          id
        )
    );

  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [showConfirmUserDialog, setShowConfirmUserDialog] = useState(false);
  const [userToConfirm, setUserToConfirm] = useState();
  const [debouncedInputStudioValue, setDebouncedInputStudioValue] =
    useState("");
  const [debouncedInputOperatorValue, setDebouncedInputOperatorValue] =
    useState("");
  const [orderDirection, setOrderDirection] = useState("desc");
  const [valueToOrderBy, setValueToOrderBy] = useState("lastDocUploadedAt");

  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });

  const pageStudio = {
    currentPage: 1,
    startRow: 0,
    endRow: 5,
  };
  const [user, setUser] = useState();
  const [userDetail, setUserDetail] = useState();
  const [debouncedInputUserValue, setDebouncedInputUserValue] = useState("");
  const [debouncedInputCompanyValue, setDebouncedInputCompanyValue] =
    useState("");
  const [filter, setFilter] = useState({
    studioId: "",
    userCompanyId: "",
    adminId: "",
    service: "",
    employment: "",
    withDocuments: "",
  });

  const userFilter = !user ? "" : user.name + " " + user.surname;

  const {
    data: dataUser,
    isLoading,
    isFetching,
    refetch,
  } = useGetUsersQuery({
    page,
    value: userFilter,
    filter,
    orderDirection,
    valueToOrderBy,
  });
  const {
    data: usersSelect,
    isLoading: isUsersSelectLoading,
    isFetching: isUsersSelectFetching,
  } = useGetUsersQueryForSelect({
    page: { startRow: 0, endRow: 50 },
    value: debouncedInputUserValue,
    filter,
    orderDirection,
    valueToOrderBy,
  });
  const {
    data: companiesList,
    isLoading: isCompanySelectLoading,
    isFetching: isCompanySelectFetching,
  } = useGetCompaniesQuery({
    startRow: 0,
    endRow: 10,
    query: debouncedInputCompanyValue,
  });
  const { data: adminStudio } = useGetStudiosQuery({
    ...pageStudio,
    value: debouncedInputStudioValue,
    ...{
      skip: role !== ROLE.ADMIN,
    },
  });
  const {
    data: operatorsData,
    isLoading: isOperatorsLoading,
    isFetching: isOperatorsFetching,
  } = useGetCommercialistaQuery({
    page: { startRow: 0, endRow: 10 },
    value: debouncedInputOperatorValue,
  });
  const { data: practiceServicesData } = useGetPracticesServicesQuery();
  const { data: dataListCategory } = useGetProfileCategoryQuery();
  const [associateUser, { isLoading: associationLoading }] =
    useAssociateUserMutation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleFilterNavigate = (el) => {
      role === ROLE.ADMIN
        ? navigate(`/auth/admin/${t("documentManagement")}`, { state: el })
        : role === ROLE.BUSINESS && subrole === SUB_ROLE.ADMIN
        ? navigate(`/auth/business/${t("documentManagement")}`, { state: el })
        : navigate(`/auth/operator/${t("documentManagement")}`, { state: el });
    };

    const handleFilterChat = (el) => {
      role === ROLE.ADMIN
        ? navigate(`/auth/admin/${t("chat")}`, { state: el })
        : role === ROLE.BUSINESS && subrole === SUB_ROLE.ADMIN
        ? navigate(`/auth/business/${t("chat")}`, { state: el })
        : navigate(`/auth/operator/${t("chat")}`, { state: el });
    };

    const navigateToUploadDocuments = (userObject) => {
      role === ROLE.BUSINESS
        ? subrole === SUB_ROLE.ADMIN
          ? navigate("/auth/business/" + t("uploadDocuments"), {
              state: userObject,
            })
          : navigate("/auth/operator/" + t("uploadDocuments"), {
              state: userObject,
            })
        : navigate("/auth/admin/" + t("uploadDocuments"), {
            state: userObject,
          });
    };

    const isValidation = dataUser && dataUser.Data && dataUser.Data.items;
    if (isValidation) {
      // tutti i dati degli utenti
      const userData = dataUser?.Data?.items.map((el) => ({
        Id: el.id,
        [t("Name")]: el.displayName,
        [t("CF") + "/" + t("VAT")]: el.isCompany
          ? el?.userCompany?.vat || <p className="italic">N/A</p>
          : el.fiscalCode,
        [t("LastSubmission")]: (
          <p className="w-32"> {formatItalianDate(el.lastDocUploadedAt)}</p>
        ),
        Email: el.email,
        ...(appConfig?.modules?.company?.general && {
          [t("Company")]: el.userCompanyName || <p className="italic">N/A</p>,
        }),
        ...(ROLE.ADMIN === role && {
          [t("Studio")]: el.studio?.name || <p className="italic">N/A</p>,
        }),
        [t("Type")]: el.employmentStatusName || <p className="italic">N/A</p>,
        [t("Actions")]: [
          {
            icon: el.isCompany ? (
              <SearchRoundedIcon />
            ) : (
              <AssignmentIndRoundedIcon />
            ),
            onClick: el.isCompany
              ? () => {
                  role === ROLE.BUSINESS
                    ? navigate(
                        `/auth/business/${t("edit-company")}/${
                          el.userCompanyId
                        }`
                      )
                    : navigate(
                        `/auth/admin/${t("edit-company")}/${el.userCompanyId}`
                      );
                }
              : () => {
                  handleOpen(el);
                },
            show: true,
            tooltip: el.isCompany
              ? `${t("Card")} ${t("Company")}`
              : `${t("Card")} ${t("user")}`,
          },
          {
            icon: (
              <Badge badgeContent={el.pendingDocsCount} color="error">
                <DriveFolderUploadRoundedIcon />
              </Badge>
            ),
            onClick: () => {
              handleFilterNavigate(el);
            },
            show: el.adminConfirmed && !el.isCompany,
            tooltip: t("DocumentsManagement"),
          },

          {
            icon: (
              <Badge badgeContent={el.unreadConversations} color="error">
                <ChatRoundedIcon />
              </Badge>
            ),
            onClick: () => handleFilterChat(el),
            show: appConfig?.modules?.chat?.general && !el.isCompany,
            tooltip: t("Chat"),
          },
          {
            icon: <UploadFileRoundedIcon /* className="fill-green-500" */ />,
            onClick: () => {
              navigateToUploadDocuments({
                id: el.id,
                name: el.name,
                surname: el.surname,
              });
            },
            show: el.adminConfirmed && !el.isCompany,
            tooltip: t("Upload") + " " + t("documents"),
          },
          {
            icon: (
              <HowToRegRoundedIcon className="text-orange-600 animate-pulse" />
            ),
            onClick: () => {
              handleOpenConfirm(el);
            },
            show: !el.adminConfirmed,
            tooltip: t("ConfirmUser"),
          },
        ].map(
          (action, index) =>
            action.show && (
              <Tooltip title={action.tooltip} key={index}>
                <IconButton variant="outlined" onClick={action.onClick}>
                  {action.icon}
                </IconButton>
              </Tooltip>
            )
        ),
      }));
      const rowsWithStyles = userData.map((row) => ({
        ...row,
        style: {
          backgroundColor: row[t("Actions")][4]
            ? "rgba(173, 173, 173, 0.133)"
            : "",
        },
      }));
      setRows(rowsWithStyles);
    }
  }, [dataUser, navigate, role, subrole, t, appConfig]);

  const handleOpen = (u) => {
    setUserDetail(u);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDownload = () => {
    toast.info(t("HandleDownload"));
    dispatch(doReportUtente());
  };

  // CONFIRM LOGIC
  const handleOpenConfirm = (u) => {
    setUserToConfirm(u);
    setShowConfirmUserDialog(true);
  };

  const handleCloseConfirm = () => {
    setShowConfirmUserDialog(false);
    setUserToConfirm(null);
  };

  const handleConfirmUser = async () => {
    associateUser(userToConfirm.id)
      .then(() => {
        toast.success(t("UserAssociated"));
        handleCloseConfirm();
      })
      .catch(() => {
        toast.error(t("UserNotAssociated"));
      });
  };

  const handleRemoveFilter = (f) => {
    let newFilter = { ...filter };
    Object.entries(newFilter).forEach(([k, v]) => {
      if (v === f) newFilter[k] = "";
    });
    setFilter(newFilter);
  };

  const handleRefecthDocuments = () => {
    refetch();
  };

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <CoreSpinner />;
  }

  return (
    <div>
      <div className="w-full">
        <div className="flex flex-row items-center space-x-4">
          <h2>{t("ManageUsers")}</h2>
        </div>
        <div className="flex flex-row -mt-12 justify-end space-x-2">
          {Object.entries(filter).map(
            ([k, v]) =>
              v !== "" && (
                <CoreChip
                  key={v}
                  label={labelForFilterGestioneUser(
                    k,
                    v,
                    withDocumentsStatus,
                    adminStudio,
                    companiesList,
                    operatorsData,
                    practiceServicesData,
                    dataListCategory
                  )}
                  variant="outlined"
                  onDelete={() => handleRemoveFilter(v)}
                />
              )
          )}
          <GestioneUtentiFilter
            filter={filter}
            setFilter={setFilter}
            withDocumentsStatus={withDocumentsStatus}
            studios={adminStudio}
            admin={role === "Admin" ? true : false}
            setDebouncedInputStudioValue={setDebouncedInputStudioValue}
            companies={companiesList}
            isCompanyLoading={isCompanySelectFetching || isCompanySelectLoading}
            setDebouncedInputCompanyValue={setDebouncedInputCompanyValue}
            operators={operatorsData}
            isOperatorsLoading={isOperatorsFetching || isOperatorsLoading}
            setDebouncedInputOperatorValue={setDebouncedInputOperatorValue}
            services={practiceServicesData}
            employmentList={dataListCategory}
          />
        </div>
        <div className="flex pb-4 space-x-4 items-center">
          <div className="w-4/12">
            <UserFilter
              selectedUser={user}
              setSelectedUser={setUser}
              usersList={usersSelect?.Data?.items}
              setDebouncedInputUserValue={setDebouncedInputUserValue}
              isUsersLoading={isUsersSelectLoading || isUsersSelectFetching}
            />
          </div>
          <div>
            <CoreButtonHoverIcon
              onClick={handleRefecthDocuments}
              className="text-blue-500 m-1 flex flex-row space-x-2 border"
              testo={t("Refresh")}
              icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
            />
            <CoreButtonHoverIcon
              className="text-blue-500 m-1"
              icon={<AddBoxRoundedIcon className={`fill-blue-700`} />}
              testo={`${t("User")}`}
              onClick={() =>
                navigate(`${t("create")}-${t("user")}`, {
                  state: { operator: false },
                })
              }
            />
            <CoreButtonHoverIcon
              className={"m-1 text-darkgray"}
              icon={
                <DownloadRoundedIcon
                  fontSize="small"
                  className="text-darkgray"
                />
              }
              testo="Report"
              onClick={handleDownload}
            />
          </div>
        </div>
      </div>
      {showConfirmUserDialog && userToConfirm && (
        <CoreDialog
          open={true}
          title={`${t("Confirm")} ${t("user")}`}
          content={`${t("UserConfirmAssociation")} ${userToConfirm.name}${" "}
        ${userToConfirm.surname} ${t("toYourStudio")}?`}
          negativeButton={t("Cancel")}
          positiveButton={associationLoading ? t("Wait") : t("Confirm")}
          disabledButton={associationLoading}
          handlePositive={handleConfirmUser}
          closeDialog={handleCloseConfirm}
        />
      )}

      <CoreTable
        rows={rows}
        columns={columns}
        idsSort={sortIds}
        valueToOrderBy={valueToOrderBy}
        setValueToOrderBy={setValueToOrderBy}
        orderDirection={orderDirection}
        setOrderDirection={setOrderDirection}
        page={page}
        setPage={setPage}
        totalPages={Math.ceil(dataUser?.Data?.count / TABLE_ROWS_NUMBER) || 1}
        isLoading={isLoading || isFetching}
      />

      <CoreModal
        width={"100%"}
        height={"100%"}
        state={open}
        onClose={handleClose}
        component={
          <SchedaUtente userId={userDetail?.id} onClose={handleClose} />
        }
      />
    </div>
  );
};

export default GestisciUtentiPage;
